/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskDetectionScope = {
  /**
   * Risk category key this detection scope applies to.
   */
  category: string;
  /**
   * CEL exemption predicate: the category skips a message when this boolean expression is true. Empty means no exemption.
   */
  scopeExempt?: string | undefined;
  /**
   * CEL scope predicate: the category detects on a message only when this boolean expression is true. Empty means every message surface is included.
   */
  scopeInclude?: string | undefined;
};

/** @internal */
export const RiskDetectionScope$inboundSchema: z.ZodMiniType<
  RiskDetectionScope,
  unknown
> = z.pipe(
  z.object({
    category: z.string(),
    scope_exempt: z.optional(z.string()),
    scope_include: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "scope_exempt": "scopeExempt",
      "scope_include": "scopeInclude",
    });
  }),
);
/** @internal */
export type RiskDetectionScope$Outbound = {
  category: string;
  scope_exempt?: string | undefined;
  scope_include?: string | undefined;
};

/** @internal */
export const RiskDetectionScope$outboundSchema: z.ZodMiniType<
  RiskDetectionScope$Outbound,
  RiskDetectionScope
> = z.pipe(
  z.object({
    category: z.string(),
    scopeExempt: z.optional(z.string()),
    scopeInclude: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      scopeExempt: "scope_exempt",
      scopeInclude: "scope_include",
    });
  }),
);

export function riskDetectionScopeToJSON(
  riskDetectionScope: RiskDetectionScope,
): string {
  return JSON.stringify(
    RiskDetectionScope$outboundSchema.parse(riskDetectionScope),
  );
}
export function riskDetectionScopeFromJSON(
  jsonString: string,
): SafeParseResult<RiskDetectionScope, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskDetectionScope$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskDetectionScope' from JSON`,
  );
}
